module.exports = __webpack_public_path__ + "static/Javascript_Balloon-94ebd0ee246aa54d6a26703539e13cfb.png";